export const mapCreditorsResponseToReduxStore = (documentsArray = []) =>
  documentsArray.map((item) => ({
    clientName: item.accountName,
    clientId: item.accountCode,
    remainingAmount: item.credit,
  }));
